<template>
  <div>
    <v-card>
      <v-card-title>
        <h2>BOLSAS</h2>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <AgregarGeneracion @agregado="generacionAgregado" />
            <GeneracionAutocomplete
              :key="updateGeneracionAutocomplete"
              ref="asig"
              returnObject
              :filtroEstado="[
                'Pendiente',
                'Cerrado',
                'Liquidado',
                'Liquidando',
              ]"
              @generacionId="setGeneracionId"
            />
          </v-col>
          <v-col>
            <AgregarEscenario
              @agregado="generacionAgregado"
              v-if="generacion"
              :generacionId="generacion.id"
            />
            <EscenarioAutocomplete
              v-if="generacion"
              :key="updateEscenarioAutocomplete"
              ref="asig"
              returnObject
              :generacionId="generacionId"
              :filtroEstado="[
                'Pendiente',
                'Cerrado',
                'Liquidado',
                'Liquidando',
              ]"
              @setEscenario="setEscenario"
            />
          </v-col>
          <v-col cols="2">
            <ClonarBolsa
              v-if="generacion"
              :generacionId="generacionId"
              @clonado="clonado"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-progress-linear
            indeterminate
            rounded
            :active="loading"
          ></v-progress-linear>
        </v-row>
        <v-row justify="center">
          <div v-if="bolsas && bolsas.length == 0">
            <h3>sin registros de bolsas</h3>
          </div>
          <h3 v-if="generacion && generacion.estado == 'Liquidando'">
            La distribucion se esta procesando . . .
          </h3>
          <v-expansion-panels popout focusable>
            <v-expansion-panel v-for="(bolsa, i) in bolsas" :key="i">
              <v-expansion-panel-header>
                <v-row no-gutters align="center">
                  <v-col cols="4"> {{ bolsa.nombre }} </v-col>
                  <v-divider vertical class="mx-3"></v-divider>
                  <v-col cols="2" class="text-right">
                    <v-layout fluid align-center justify-end>
                      <b>Gs.{{ bolsa.monto | numberFormat }}</b>
                      <ActualizarMontoBolsa
                        v-if="editable"
                        @nuevoMontoBolsa="nuevoMontoBolsa"
                        :id="bolsa.id"
                        :monto="bolsa.monto"
                      />
                    </v-layout>
                    
                  </v-col>

                  <v-divider vertical class="mx-3"></v-divider>
                  <v-col cols="4" class="text-right">
                    
                    <v-layout fluid align-center justify-end>
                      
                      <div class="text-caption my-0 mx-3" v-if="bolsa.bolsaPrincipalDetalle">
                        <p class="my-0">{{ bolsa.bolsaPrincipalDetalle.bolsaPrincipal.descripcion }}</p>
                        <p class="my-0">{{ bolsa.bolsaPrincipalDetalle.rubroDistribucion.descripcion }}</p>
                      </div>


                      
                      <ActualizarBolsaPrincipal

                        @nuevoBolsaPrincipalDetalle="nuevoBolsaPrincipalDetalle"
                        :bolsaId="bolsa.id"
                        :bolsas="bolsasPrincipal"
                      />
                    </v-layout>
                    
                  </v-col>


                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>Regla</th>
                            <th>Asignacion</th>
                            <th>Origen</th>
                            <th>Valores</th>
                            <th></th>
                            <th class="text-right">Registros</th>
                            <th class="text-right">Segundos</th>
                            <th class="text-right">VPS</th>
                            <th class="text-right">Monto</th>
                            <th></th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="regla in bolsa.reglas" :key="regla.id">
                            <td>{{ regla.descripcion }}</td>
                            <td>{{ regla.asignacion.nombre }}</td>
                            <td>{{ regla.origen }}</td>
                            <td>
                              <v-layout>
                                <v-row align="center">
                                  <v-col>
                                    <div
                                      v-for="valor in regla.valores"
                                      :key="valor.id"
                                      class="text-no-wrap"
                                    >
                                      {{ valor.nombre }} :
                                      <b>{{ valor.valor }}</b>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-layout>
                            </td>
                            <td>
                              <ActualizarReglaBMAT
                                v-if="editable && regla.origen === 'BMAT'"
                                :regla="regla"
                                @actualizado="actualizarRegla"
                              />
                              <ActualizarReglaPLDP
                                v-if="editable && regla.origen === 'PLDP'"
                                :regla="regla"
                                @actualizado="actualizarRegla"
                              />
                              <ActualizarReglaMFSO
                                v-if="editable && regla.origen === 'MFSO'"
                                :regla="regla"
                                @actualizado="actualizarRegla"
                              />
                              <ActualizarReglaPLMF
                                v-if="editable && regla.origen === 'PLMF'"
                                :regla="regla"
                                @actualizado="actualizarRegla"
                              />
                              <ActualizarReglaINT
                                v-if="editable && regla.origen === 'INT'"
                                :regla="regla"
                                @actualizado="actualizarRegla"
                              />
                            </td>
                            <td class="text-right">
                              {{ regla.registros | numberFormat }}
                            </td>
                            <td class="text-right">
                              {{ regla.segundos | numberFormat }}
                            </td>

                            <td class="text-right">
                              {{ regla.vps | vpsFormat }}
                            </td>
                            <td class="text-right">
                              {{ regla.monto | numberFormat }}
                            </td>
                            <!-- <td><v-btn small color="primary">ELIMINAR</v-btn></td> -->
                            <td>
                              <!-- <v-btn small color="primary">EDITAR</v-btn> -->
                            </td>
                            <td>
                              <ConfirmarIcon
                                small
                                v-if="editable"
                                :texto="`¿Desea eliminar la regla ${regla.descripcion}?`"
                                @si="deleteRegla(regla)"
                              />
                            </td>
                            <td>
                              <v-icon @click="descargar(regla.id)"
                                >download</v-icon
                              >
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                  <v-card-actions>
                    <Confirmar
                      color="primary"
                      text
                      v-if="editable"
                      boton="eliminar bolsa"
                      @si="deleteBolsa(bolsa)"
                      :texto="`¿Desdea eliminar la bolsa ${bolsa.nombre} y todas sus reglas?`"
                    />
                    <AgregarRegla
                      :bolsa="bolsa"
                      @actualizado="leer"
                      v-if="editable"
                    />
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <AgregarBolsa
            :escenario="escenario"
            v-if="editable"
            @actualizado="leer"
          />
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="leer" v-if="generacion">Leer</v-btn>
        <v-btn
          color="warning"
          @click="liquidarVPS"
          :disabled="!this.bolsas.length > 0"
          :loading="liquidando"
          v-if="editable"
          >CALCULAR VPS</v-btn
        >
        <v-btn
          color="warning"
          @click="liquidar"
          :disabled="!this.bolsas.length > 0"
          :loading="liquidando"
          v-if="editable"
          >LIQUIDAR</v-btn
        >

        <v-btn
          color="warning"
          @click="cerrarEscenario"
          :loading="cerrando"
          v-if="escenario && escenario.estado == 'Liquidado'"
          >CERRAR</v-btn
        >

        <v-btn
          color="warning"
          @click="revertirLiquidar"
          :loading="revirtiendo"
          v-if="escenario && escenario.estado == 'Liquidado'"
          >REVERTIR LIQUIDAR</v-btn
        >

        <v-btn @click="descargarRerpoteReglas(escenario.id)" v-if="generacion">
          <v-icon small>download</v-icon>
          REGLAS
        </v-btn>

        <v-btn
          @click="descargarTotales(escenario)"
          v-if="escenario && (escenario.estado == 'Liquidado' || escenario.estado == 'Cerrado')"
        >
          <v-icon small>download</v-icon>
          TOTALES
        </v-btn>
        <v-btn @click="descargarComparativo">
          <v-icon small>download</v-icon>
          COMPARATIVO
        </v-btn>
      </v-card-actions>
      <h4 v-if="errorMessage" class="pa-3 red--text">{{ errorMessage }}</h4>
    </v-card>
  </div>
</template>

<script>
import GeneracionAutocomplete from "@/components/shared/GeneracionAutocomplete.vue";
import EscenarioAutocomplete from "@/components/shared/EscenarioAutocomplete.vue";
import ConfirmarIcon from "@/components/shared/ConfirmarIcon.vue";
import Confirmar from "@/components/Confirmar.vue";
import ActualizarMontoBolsa from "@/components/bolsas/ActualizarMontoBolsa.vue";
import ActualizarBolsaPrincipal from "@/components/bolsas/ActualizarBolsaPrincipal.vue";
import ActualizarReglaBMAT from "@/components/bolsas/ActualizarReglaBMAT.vue";
import ActualizarReglaINT from "@/components/bolsas/ActualizarReglaINT.vue";
import ActualizarReglaPLDP from "@/components/bolsas/ActualizarReglaPLDP.vue";
import ActualizarReglaMFSO from "@/components/bolsas/ActualizarReglaMFSO.vue";
import ActualizarReglaPLMF from "@/components/bolsas/ActualizarReglaPLMF.vue";
import AgregarRegla from "@/components/bolsas/AgregarRegla.vue";
import AgregarBolsa from "@/components/bolsas/AgregarBolsa.vue";
import ClonarBolsa from "@/components/bolsas/ClonarBolsa.vue";
import AgregarGeneracion from "@/components/distribucion/AgregarGeneracion.vue";
import AgregarEscenario from "@/components/bolsas/AgregarEscenario.vue";
import numeral from "numeral";
import axios from "axios";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      headers: [
        { text: "Nombre", value: "nombre" },
        { text: "Monto", value: "monto" },
        { text: "Accion", value: "controls", sortable: false },
      ],
      errorMessage: "",
      loading: false,
      liquidando: false,
      revirtiendo: false,
      cerrando: false,
      generacionId: null,
      generacion: null,
      escenario: null,
      bolsas: null,
      bolsasPrincipal: null,
      updateGeneracionAutocomplete: 1,
      updateEscenarioAutocomplete: 1,
    };
  },
  methods: {
    generacionAgregado() {
      this.updateGeneracionAutocomplete++;
      this.updateEscenarioAutocomplete++;
    },
    async leer() {
      this.loading = true;
      this.errorMessage = "";

      await axios
        .get(`/generaciones/${this.generacion.id}`)
        .then((response) => {
          console.log("**** getGeneracion", response);
          this.generacion = response.data;
          this.generacionId = response.data.id;
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });

      await axios
        .get("/bolsa?escenarioId=" + this.escenario.id)
        .then((response) => {
          console.log("response.data", response.data);
          this.bolsas = response.data;
          this.loading = false;
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });

        if ( this.generacion && this.generacion.periodoDistribucion) {

          const params = {
            periodoDistribucionId: this.generacion.periodoDistribucion.id
          };
  
          await axios.get('/bolsaPrincipal/', { params }).then(response => {
            this.bolsasPrincipal = response.data;
          }).catch(error => {
            console.log(error);
          });

        }

      this.loading = false;
    },
    // async procesar() {
    //   for (let bolsa of this.bolsas) {
    //     bolsa.estado = "Procesando";
    //     await this.procesarBolsa(bolsa);
    //     bolsa.estado = "Procesado";
    //   }
    // },
    // async procesarBolsa(bolsa) {
    //   await axios
    //     .post(`/bolsa/${bolsa.id}/procesar`)
    //     .then((response) => {
    //       const foundIndex = this.bolsas.findIndex((b) => b.id === bolsa.id);
    //       if (foundIndex >= 0) {
    //         this.bolsas[foundIndex].reglas = response.data.reglas;
    //       }
    //     })
    //     .catch((err) => {
    //       this.message = "";
    //       this.loading = false;
    //       console.log(err);
    //       if (err.response.data) {
    //         this.errorMessage = err.response.data;
    //       } else {
    //         this.errorMessage = "Error";
    //       }
    //     });
    // },
    liquidar() {
      if (!confirm("desera iniciar la liquidacion?")) return;

      this.errorMessage = "";
      this.liquidando = true;
      axios
        .post(`/escenario/${this.escenario.id}/liquidar?soloVPS=false`)
        .then((response) => {
          this.liquidando = false;
          this.updateGeneracionAutocomplete++; //force Generacion re-mount
          this.escenario.estado = "Liquidado";
          this.leer();
          console.log(response);
        })
        .catch((err) => {
          this.liquidando = false;
          this.errorMessage = err.response.data;
          console.log(err);
        });
    },
    liquidarVPS() {
      if (!confirm("desera calcular los vps? ")) return;

      this.errorMessage = "";
      this.liquidando = true;
      axios
        .post(`/escenario/${this.escenario.id}/liquidar?soloVPS=true`)
        .then((response) => {
          this.liquidando = false;
          this.updateGeneracionAutocomplete++; //force Generacion re-mount
          this.leer();
          console.log(response);
        })
        .catch((err) => {
          this.liquidando = false;
          this.errorMessage = err.response.data;
          console.log(err);
        });
    },
    revertirLiquidar() {
      if (!confirm("desera reverit la liquidacion?")) return;

      this.errorMessage = "";
      this.revirtiendo = true;
      axios
        .post(`/escenario/${this.escenario.id}/revertirLiquidar`)
        .then((response) => {
          this.revirtiendo = false;
          this.escenario.estado = "Pendiente";
          this.leer();
          console.log(response);
        })
        .catch((err) => {
          this.revirtiendo = false;
          this.errorMessage = err.response.data;
          console.log(err);
        });
    },
    cerrarEscenario() {
      if (!confirm("desera cerrar el escenario?")) return;

      this.errorMessage = "";
      this.cerrando = true;

      axios
        .post(`/escenario/${this.escenario.id}/cerrar`)
        .then((response) => {
          this.cerrando = false;
          this.escenario.estado = "Cerrado";
          this.leer();
          console.log(response);
        })
        .catch((err) => {
          this.cerrando = false;
          this.errorMessage = err.response.data;
          console.log(err);
        });
    },
    setGeneracionId(generacion) {
      this.bolsas = null;
      this.generacion = generacion;
      this.generacionId = generacion.id;
      this.updateEscenarioAutocomplete++;
    },
    setEscenario(escenario) {
      this.escenario = escenario;
      this.bolsas = [];
    },
    nuevoMontoBolsa(dato) {
      const foundIndex = this.bolsas.findIndex((b) => b.id === dato.bolsaId);
      if (foundIndex >= 0) {
        this.bolsas[foundIndex].monto = dato.nuevoMontoBolsa;
      }
    },
    nuevoBolsaPrincipalDetalle(dato) {
      const foundIndex = this.bolsas.findIndex((b) => b.id === dato.bolsaId);
      if (foundIndex >= 0) {
        this.bolsas[foundIndex].bolsaPrincipalDetalle = dato.bolsa.bolsaPrincipalDetalle;
      }
    },


    clonado() {
      //this.setGeneracionId(generacionNew);
      this.updateGeneracionAutocomplete++;
    },
    actualizarRegla(regla) {
      console.log(regla);
      this.leer();
      // this.bolsas.forEach(bolsa=> {
      //   const idx = bolsa.reglas.findIndex((r) => r.id === regla.id);
      //   if (idx >= 0) {
      //     bolsa.reglas[idx] = regla;
      //   }
      // })

      // this.bolsas = this.bolsas.filter(b => b);
      // // console.log(this.bolsas);
    },
    deleteRegla(regla) {
      console.log("delete regla", regla);
      axios
        .delete(`/regla/${regla.id}`)
        .then((response) => {
          console.log(response);
          this.leer();
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    deleteBolsa(bolsa) {
      axios
        .delete(`/bolsa/${bolsa.id}`)
        .then((response) => {
          console.log(response);
          this.leer();
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    descargar(reglaId) {
      this.loading = true;
      axios
        .get(`/regla/descargarDetalle?reglaId=${reglaId}`)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/excel",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    descargarTotales(escenario) {
      this.loading = true;
      axios
        .get("/report/escenario/totales/" + escenario.id)
        .then((response) => {
          this.loading = false;

          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);

          // this.$store.dispatch("showSnack", "Descargando..!");
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
          // this.$store.dispatch("showSnack", "Error");
        });
    },
    descargarComparativo() {
      this.loading = true;
      axios
        .get(`/escenario/descargarComparativo`)
        .then((response) => {
          this.loading = false;
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/excel",
            null
          );
          saveAs(blob, response.data.fileName);

          // this.$store.dispatch("showSnack", "Descargando..!");
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
          // this.$store.dispatch("showSnack", "Error");
        });
    },
    descargarRerpoteReglas(escenarioId) {
      this.loading = true;
      axios
        .get(`/report/reglas/${escenarioId}`)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  },
  computed: {
    editable() {
      if (
        this.escenario &&
        this.escenario.estado == "Pendiente" &&
        this.bolsas
      ) {
        return true;
      }
      return false;
    },
  },
  components: {
    AgregarEscenario,
    AgregarGeneracion,
    GeneracionAutocomplete,
    ActualizarMontoBolsa,
    ActualizarBolsaPrincipal,
    ClonarBolsa,
    ActualizarReglaBMAT,
    ActualizarReglaINT,
    ConfirmarIcon,
    Confirmar,
    AgregarRegla,
    AgregarBolsa,
    ActualizarReglaPLDP,
    ActualizarReglaMFSO,
    ActualizarReglaPLMF,
    EscenarioAutocomplete,
  },
  filters: {
    numberFormat(value) {
      if (!isNaN(value)) {
        return numeral(+value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
      }
    },
    vpsFormat(value) {
      if (!isNaN(value)) {
        return numeral(+value).format("#,##0.0000"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
};
</script>